export default{dataTableCell:"w_GZ",alphanumeric:"w_Ga",numeric:"w_Gb"};
